import React from 'react';

import './tag.scss';

const Tag = ({className, children}) => {
  return (<span className={`tag ${className}`}>{children}</span>);
}

export default Tag;